import { render, staticRenderFns } from "./RegistrationPaymentData.vue?vue&type=template&id=0509360a"
import script from "./RegistrationPaymentData.vue?vue&type=script&lang=js"
export * from "./RegistrationPaymentData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports